import { createAction, props } from '@ngrx/store';
import { IUserNotification } from '@webtronic-labs/contracts-hip-hip';

// ------------------- Main ------------------- //

export const setNotifications = createAction(
  '[Notifications] Set current notifications',
  props<{ notifications: IUserNotification[] }>()
);
